// src/hooks/usePromotionAck.js
// Detecta si el rol de la cuenta pasó a mentor/admin desde la última vez que la
// persona lo confirmó (dismiss). El ack vive en profile.roleAckedAs (Firestore), no
// en localStorage — un ack por navegador reaparecía cada vez que la persona entraba
// desde un dispositivo o navegador distinto. Usado por el banner de /mi-cuenta/
// (antes /discipulo/, fusionado en U3) y por el punto dorado del ícono de cuenta en
// Layout.js (ver project-log/initiatives/paneles-discipulo-lider.md, Fase extra 3).

import { useState, useEffect } from "react";
import { ackRolePromotion } from "../services/auth-service";

export function usePromotionAck(uid, role, roleAckedAs) {
  const [pending, setPending] = useState(false);
  const isPromoted = role === "mentor" || role === "admin";

  useEffect(() => {
    setPending(isPromoted && roleAckedAs !== role);
  }, [isPromoted, role, roleAckedAs]);

  function dismiss() {
    setPending(false);
    if (uid && role) {
      ackRolePromotion(uid, role).catch((err) => console.error("[roleAck]", err));
    }
  }

  return { pending, dismiss };
}
